import { styled } from '@mui/material';

export const OverviewContainer = styled('div')({
  flex: '1 1 auto',
  padding: '20px 22px 15px 22px',
  borderRadius: 8,
  backgroundColor: '#FFFFFF',
  minHeight: 100,
});
